import { defineStore } from 'pinia'

export const useSettingsStore = defineStore('settings', {
  state: () => ({
    theme: '#409EFF',
    tagsIcon: true,
    showSettings: true,
    tagsView: true,
    fixedHeader: false,
    sidebarLogo: false,
    supportPinyinSearch: false,
    title: '跳绳小凡活动系统'
  }),
  
  getters: {
    getTheme: (state) => state.theme,
    getTagsIcon: (state) => state.tagsIcon,
    getShowSettings: (state) => state.showSettings,
    getTagsView: (state) => state.tagsView,
    getFixedHeader: (state) => state.fixedHeader,
    getSidebarLogo: (state) => state.sidebarLogo,
    getSupportPinyinSearch: (state) => state.supportPinyinSearch,
    getTitle: (state) => state.title
  },
  
  actions: {
    changeSetting({ key, value }) {
      if (Object.prototype.hasOwnProperty.call(this, key)) {
        this[key] = value
      }
    }
  }
})
